/* tslint:disable */
/* eslint-disable */
/**
 * Document API
 * API for managing documents
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { DeleteDocumentResponseFromJSON, DocumentFromJSON, DocumentDownloadUrlResponseFromJSON, DocumentStatusResponseFromJSON, DocumentUploadUrlRequestToJSON, DocumentUploadUrlResponseFromJSON, ListDocumentsResponseFromJSON, UpdateDocumentRequestToJSON, UpdateDocumentResponseFromJSON, } from '../models/index';
/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
    /**
     * Delete a document
     */
    v1DocumentsDocumentIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['documentId'] == null) {
                throw new runtime.RequiredError('documentId', 'Required parameter "documentId" was null or undefined when calling v1DocumentsDocumentIdDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/v1/documents/{documentId}`;
            urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));
            const response = yield this.request({
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DeleteDocumentResponseFromJSON(jsonValue));
        });
    }
    /**
     * Delete a document
     */
    v1DocumentsDocumentIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.v1DocumentsDocumentIdDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get a document by ID
     */
    v1DocumentsDocumentIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['documentId'] == null) {
                throw new runtime.RequiredError('documentId', 'Required parameter "documentId" was null or undefined when calling v1DocumentsDocumentIdGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/v1/documents/{documentId}`;
            urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFromJSON(jsonValue));
        });
    }
    /**
     * Get a document by ID
     */
    v1DocumentsDocumentIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.v1DocumentsDocumentIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update a document
     */
    v1DocumentsDocumentIdPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['documentId'] == null) {
                throw new runtime.RequiredError('documentId', 'Required parameter "documentId" was null or undefined when calling v1DocumentsDocumentIdPut().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/v1/documents/{documentId}`;
            urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));
            const response = yield this.request({
                path: urlPath,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateDocumentRequestToJSON(requestParameters['updateDocumentRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UpdateDocumentResponseFromJSON(jsonValue));
        });
    }
    /**
     * Update a document
     */
    v1DocumentsDocumentIdPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.v1DocumentsDocumentIdPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get document processing status
     */
    v1DocumentsDocumentIdStatusGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['documentId'] == null) {
                throw new runtime.RequiredError('documentId', 'Required parameter "documentId" was null or undefined when calling v1DocumentsDocumentIdStatusGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/v1/documents/{documentId}/status`;
            urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DocumentStatusResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get document processing status
     */
    v1DocumentsDocumentIdStatusGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.v1DocumentsDocumentIdStatusGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * List all documents
     */
    v1DocumentsGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            if (requestParameters['nextToken'] != null) {
                queryParameters['nextToken'] = requestParameters['nextToken'];
            }
            if (requestParameters['status'] != null) {
                queryParameters['status'] = requestParameters['status'];
            }
            if (requestParameters['yearMonth'] != null) {
                queryParameters['yearMonth'] = requestParameters['yearMonth'];
            }
            const headerParameters = {};
            let urlPath = `/v1/documents`;
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ListDocumentsResponseFromJSON(jsonValue));
        });
    }
    /**
     * List all documents
     */
    v1DocumentsGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.v1DocumentsGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Generate pre-signed download URL
     */
    v1FilesFileNameGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fileName'] == null) {
                throw new runtime.RequiredError('fileName', 'Required parameter "fileName" was null or undefined when calling v1FilesFileNameGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/v1/files/{fileName}`;
            urlPath = urlPath.replace(`{${"fileName"}}`, encodeURIComponent(String(requestParameters['fileName'])));
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DocumentDownloadUrlResponseFromJSON(jsonValue));
        });
    }
    /**
     * Generate pre-signed download URL
     */
    v1FilesFileNameGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.v1FilesFileNameGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Generate pre-signed upload URL
     */
    v1FilesPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/v1/files`;
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DocumentUploadUrlRequestToJSON(requestParameters['documentUploadUrlRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DocumentUploadUrlResponseFromJSON(jsonValue));
        });
    }
    /**
     * Generate pre-signed upload URL
     */
    v1FilesPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.v1FilesPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
 * @export
 */
export const V1DocumentsGetStatusEnum = {
    Queued: 'QUEUED',
    Processing: 'PROCESSING',
    Submitted: 'SUBMITTED',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
};
